module.exports = __webpack_public_path__ + "ma.svg?f1e73245fb630eece28d17ff2d81e915";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ma.svg
// module id = 1312
// module chunks = 27